module.exports = __webpack_public_path__ + "img/apple-store.582dfd71.svg";